import { normalizeErrorEntity } from 'entities/common/Error';

import { normalizeControllerEntity } from '../TableControllers';

import { TableCellEntityApi, TableCellEntity } from './entity';

export const normalizeTableCellEntity = (
  raw: TableCellEntityApi
): TableCellEntity => {
  return {
    comments: raw.comments,
    fieldId: raw.field_id,
    mode: raw.mode,
    errors: raw.errors && raw.errors.map(normalizeErrorEntity),
    ...normalizeControllerEntity(raw),
  };
};
